import { useRouter } from 'next/router'
import { filter } from 'lodash-es'
import { cls } from 'tagged-classnames-free'

import { ALL_LANGUAGES } from './data'

import CustomSelect from '@/components/antd/CustomSelect'
import Link from '@/components/Link'

export default function LanguageSwitcher({ locales }: { locales: string[] }) {
  const { locale, asPath } = useRouter()
  const localesList =
    locales && locales.length > 0
      ? filter(ALL_LANGUAGES, (item) => locales?.includes(item.locale))
      : ALL_LANGUAGES

  const options = localesList.map((item) => {
    return {
      key: item.abbr,
      value: item.abbr,
      label: <span className='text-sm text-white/70'>{item.language}</span>,
      labelWithLink: (
        <Link
          className={cls`
            text-f-text hover:text-f-primary inline-block w-full px-2 py-1.5 text-sm
          `}
          locale={item.abbr}
          href={asPath}
        >
          {item.language}
        </Link>
      ),
    }
  })

  return (
    <CustomSelect
      className={cls`
        !border-1 !border-white/16 rounded-md
        [&_.coco-select-arrow_span]:!text-white/45
      `}
      classNames={{
        popup: {
          root: cls`
            [&_.coco-select-item-option]:!p-0
          `,
        },
      }}
      prefix={<span className='i-com--globe flex size-4 text-white/70' />}
      value={locale}
      options={options}
      optionRender={(option) => {
        return <>{option.data.labelWithLink}</>
      }}
      popupMatchSelectWidth={false}
    />
  )
}
